import type { RosterViewMode, WeekScheduleTab } from '../types/Rostering';
import { startOfMonth, toDateKey } from './rosterUtils';

export type { RosterViewMode };

export const parseRosterViewMode = (value: string | null | undefined): RosterViewMode => (
  value === 'month' ? 'month' : 'week'
);

export const parseMonthParam = (value: string | null | undefined, fallback: Date): Date => {
  if (value && /^\d{4}-\d{2}$/.test(value)) {
    const parsed = new Date(`${value}-01T00:00:00`);
    if (!Number.isNaN(parsed.getTime())) {
      return startOfMonth(parsed);
    }
  }

  return startOfMonth(fallback);
};

export const toMonthKey = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
};

export const parseScheduleTabParam = (value: string | null | undefined): WeekScheduleTab => (
  value === 'onCall' ? 'onCall' : 'schedule'
);

export const buildRosterListUrl = (options: {
  view: RosterViewMode;
  weekStart: Date;
  monthStart: Date;
}): string => {
  const params = new URLSearchParams();
  params.set('view', options.view);

  if (options.view === 'month') {
    params.set('month', toMonthKey(options.monthStart));
  } else {
    params.set('week', toDateKey(options.weekStart));
  }

  return `/rostering?${params.toString()}`;
};

export const buildEmployeeScheduleUrl = (options: {
  employeeId: string;
  view: RosterViewMode;
  weekStart: Date;
  monthStart: Date;
  tab?: WeekScheduleTab;
}): string => {
  const params = new URLSearchParams();
  params.set('view', options.view);

  if (options.view === 'month') {
    params.set('month', toMonthKey(options.monthStart));
  } else {
    params.set('week', toDateKey(options.weekStart));
  }

  if (options.tab) {
    params.set('tab', options.tab);
  }

  return `/rostering/employees/${options.employeeId}?${params.toString()}`;
};
